import { render, staticRenderFns } from "./book_demo.vue?vue&type=template&id=3a7a3487&scoped=true&"
import script from "./book_demo.vue?vue&type=script&lang=js&"
export * from "./book_demo.vue?vue&type=script&lang=js&"
import style0 from "./book_demo.vue?vue&type=style&index=0&id=3a7a3487&lang=scss&scoped=true&"
import style1 from "./book_demo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7a3487",
  null
  
)

export default component.exports